import React from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Grid from "@mui/material/Grid";

import { ButtonUI } from "../../../Common";
import { setPrevState } from "../../../../util/common";
import { regexName } from "../../../../util/regularExpress";

const UploadFile = (props) => {
  const { configState, setCheckedValues, setConfigState, uploadFile, setDisableList, compare, comparisonList } = props;

  const onSecretBlur = (e) => {
    if (configState.uploadedFile !== null && compare)
      setDisableList((prevState) => {
        if (e.target.value.trim().length !== 0) {
          let prevDisabled = { ...prevState };
          const newCount = comparisonList["connections"]["new"]["count"];
          const modifiedCount = comparisonList["connections"]["modified"]["count"];
          if (
            (configState.importBehavior === "newOnly" ? newCount !== 0 : newCount + modifiedCount !== 0) &&
            prevDisabled.checkBoxes.includes("connections")
          )
            prevDisabled.checkBoxes = prevDisabled.checkBoxes.filter((component) => component !== "connections");
          if (newCount + modifiedCount !== 0 && prevDisabled.subSection.includes("connections"))
            prevDisabled.subSection = prevDisabled.subSection.filter((component) => component !== "connections");
          return prevDisabled;
        } else if (!prevState.checkBoxes.includes("connections") || !prevState.subSection.includes("connections")) {
          setCheckedValues((prev) => ({
            ...prev,
            connections: { checked: false, new: [], modified: [] },
          }));

          return {
            checkBoxes: [...prevState.checkBoxes, "connections"],
            subSection: [...prevState.subSection, "connections"],
          };
        }

        return prevState;
      });
  };

  return (
    <>
      <Grid size={12}>
        <TextField
          required
          label="File"
          fullWidth
          style={{ flex: 1, maxWidth: "350px" }}
          variant="outlined"
          value={configState.file}
          placeholder=""
          helperText="Sample file name: VORTEX_DEMO.config.json"
        />
        <label htmlFor={"contained-button-file"} style={{ whiteSpace: "nowrap" }}>
          <input
            style={{ display: "none" }}
            accept=".json"
            type="file"
            id={"contained-button-file"}
            onChange={uploadFile}
          />
          <ButtonUI
            color="secondary"
            variant="contained"
            component="span"
            endIcon={<UploadFileIcon />}
            sx={{ mt: 1, ml: 3 }}
          >
            Browse
          </ButtonUI>
        </label>
      </Grid>
      <Grid sx={{ mt: 1 }} size={12}>
        <TextField
          margin="dense"
          fullWidth
          label="Secret Key"
          variant="outlined"
          helperText="Correct secret key is required if you want to import the connections from the configuration file."
          value={configState.importSecretKey}
          inputProps={{ maxLength: 32 }}
          onChange={(e) =>
            regexName(e.target.value, "alphaNumericAnyPlace") &&
            setPrevState(setConfigState, { importSecretKey: e.target.value })
          }
          onBlur={onSecretBlur}
          sx={{ maxWidth: "350px" }}
        />
      </Grid>
    </>
  );
};

UploadFile.propTypes = {
  configState: PropTypes.object.isRequired,
  setCheckedValues: PropTypes.func.isRequired,
  setConfigState: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired,
  setDisableList: PropTypes.func.isRequired,
  compare: PropTypes.func.isRequired,
  comparisonList: PropTypes.array,
};

UploadFile.defaultProps = {
  comparisonList: [],
};

export default React.memo(UploadFile);
